export default __webpack_public_path__ + "static/media/tw.2e4cc15f.svg";